import { Component, Input } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';



@Component({
  selector: 'app-dialog-close-button',
  templateUrl: './dialog-close-button.component.html',
  host: {
    'class': 'position-absolute end-0 top-0 d-inline-block mt-3 mr-3'
  }
})
export class DialogCloseButtonComponent {
  @Input()
  get disabled(): boolean {
    return this._disabled;
  };
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
  };

  private _disabled: boolean;
}
